import { render, staticRenderFns } from "./executeBoardDialog.vue?vue&type=template&id=6c452666&scoped=true"
import script from "./executeBoardDialog.vue?vue&type=script&lang=js"
export * from "./executeBoardDialog.vue?vue&type=script&lang=js"
import style0 from "./executeBoardDialog.vue?vue&type=style&index=0&id=6c452666&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c452666",
  null
  
)

export default component.exports